'use strict';
/* eslint-disable no-magic-numbers */

module.exports = {
  YIELD: 0,
  IGNORE: 1,
  STOP: 2,
};
